import { UserSetting } from '../../declarations/user-setting.interface';
import { createAction, props } from '@ngrx/store';

export const setCurrentUserSetting = createAction(
  'USER_SETTING:SET_CURRENT_USER_SETTING',
  props<UserSetting>()
);
